import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Loader from 'components/Loader';
import Grid from '../Grid';
import GridItem from '../Grid/GridItem';
import PlaylistsItem from './PlaylistsItem';

import './Playlists.scss';

const Playlists = props => {
  const { loading, error, items } = props;

  if (loading) {
    return <Grid component={Loader} />;
  }

  if (error !== false) {
    const ErrorComponent = () => (
      <GridItem item="Something went wrong, please try again!" />
    );

    return <Grid component={ErrorComponent} />;
  }

  if (!_.isEmpty(items)) {
    return (
      <Grid
        items={items}
        component={PlaylistsItem}
        className="row m-playlists"
      />
    );
  }

  return null;
};

Playlists.propTypes = {
  loading: PropTypes.bool,
  error: PropTypes.any,
  items: PropTypes.any,
};

export default Playlists;
